/**
 * Member profile
 * @export
 * @class MemberProfile
 */
export default class MemberProfile {
  public id: string = ''
  public email: string = ''
  public username: string =''
  public memberType: number = 0
  public emailVerified: boolean = false
  public isEulaConsented: boolean = false
  public needGUPLogin: boolean = false
  public tutorialStatus: string = ''
  public merchantAddr: string = ''
  public featureIds?: string[] = []
  public registeredOnCrm: boolean = false
  public gupFilledFullInfo: boolean = false

  public constructor(fields?: {
     id?: string,
     email?: string,
     emailVerified?: boolean,
     isEulaConsented?: boolean,
     needGUPLogin?: boolean,
     tutorialStatus?: string,
     memberType?: number,
     username?: string,
     merchantAddr?: string,
     featureIds?: string[],
     registeredOnCrm?: boolean
     gupFilledFullInfo?: boolean
   }) {
    if (fields) {
      Object.assign(this, fields)
    }
  }
}